<template>
  <div class="pdf1_main">
    <header>
      <div class="left">
        <h6>{{ $t("pdf.text1") }}</h6>
        <p>{{ dataList.company_name }}</p>
        <p>{{ dataList.company_address }}</p>
        <p>{{ dataList.country }}</p>
      </div>
      <div class="right">
        <div class="div">
          <p>
            <span>{{ $t("pdf.text5") }}</span>
            <span>{{ dataList.account_number }}</span>
          </p>
          <p>
            <span>{{ $t("pdf.text6") }}</span>
            <span v-if="v_lan != 'ch'"
              >{{ days }} {{ m | current_month }} {{ y }}</span
            >
            <span v-else> {{ y }}-{{ m }}-{{ days }} </span>
          </p>
        </div>
        <div>
          <p>{{ $t("pdf.text7") }}</p>
        </div>
      </div>
    </header>

    <main>
      <h6>
        <p>{{ $t("pdf.text8") }}</p>
      </h6>

      <div class="tableHeader">
        <p v-if="v_lan == 'ch'">
          截至{{ y }}年{{ m }}月{{ days }}日的USDC等值结余
        </p>
        <p v-else>
          USDC Equivalent Balance as of {{ days }} {{ m | current_month }}
          {{ y }}
        </p>
      </div>
      <table>
        <tr class="tr">
          <th></th>
          <th></th>
          <th>{{ $t("pdf.text9") }}</th>
          <th>{{ $t("pdf.text10") }}</th>
        </tr>
        <tr>
          <h6>{{ $t("pdf.text11") }}</h6>
          <td></td>
          <td>{{ set_number(dataList.total_balance) }}</td>
          <td>{{ set_number(dataList.debt_balance) }}</td>
        </tr>
        <tr>
          <h6>{{ $t("pdf.text12") }}</h6>
          <td></td>
          <td>{{ set_number(dataList.total_balance) }}</td>
          <td>{{ set_number(dataList.debt_balance) }}</td>
        </tr>
      </table>

      <div class="tableHeader">
        <p>{{ $t("pdf.text11") }}</p>
      </div>
      <table>
        <tr class="tr">
          <th>{{ $t("pdf.text13") }}</th>
          <th>{{ $t("pdf.text14") }}</th>
          <th>
            {{ $t("pdf.text15") }}
            <p>({{ $t("pdf.text16") }})</p>
          </th>
          <th>
            {{ $t("pdf.text15") }}
            <p>({{ $t("pdf.text17") }})</p>
          </th>
        </tr>
        <tr>
          <td>USD Coin</td>
          <td>USDC</td>
          <td>{{ set_number(dataList.usdc_balance) }}</td>
          <td>{{ set_number(dataList.usdc_equal) }}</td>
        </tr>
        <tr>
          <td>USD Token</td>
          <td>USDT</td>
          <td>{{ set_number(dataList.usdt_balance) }}</td>
          <td>{{ set_number(dataList.usdt_equal) }}</td>
        </tr>

        <tr class="footer_tr">
          <td></td>
          <td></td>
          <td>
            <h6>
              <p>{{ $t("pdf.text18") }}</p>
            </h6>
          </td>
          <td>
            <h6>{{ set_number(dataList.total_equal) }}</h6>
          </td>
        </tr>
      </table>
    </main>
  </div>
</template>

<script>
import BigNumber from "bignumber.js";
export default {
  filters: {
    current_month(v) {
      let en_mon_arr = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      return en_mon_arr[v - 1];
    },
  },
  props: {
    dataList: {
      default: {},
    },
    y: {
      default: "",
    },
    m: {
      default: "",
    },
    days: {
      default: "",
    },
  },
  data() {
    return {
      d: "data",
    };
  },
  mounted() {},
  methods: {
    set_number(n){
      // 初始化一个数字
      let num = new BigNumber(n);
      // 保留两位小数向下取整
      let downRounded = num.decimalPlaces(2, BigNumber.ROUND_FLOOR);
      let n2 = downRounded.toFixed(); // 输出 "12.34"
      return this.set_num3(n2*1);
    }
  },
  watch: {},
};
</script>

<style scoped lang="less">
/* a4纸的尺寸[595.28,841.89] */
h5 {
  font-size: 22px;
}
h6 {
  font-size: 18px;
}
.pdf1_main {
  font-size: 14px;
  // transform: scale(0.5);
  width: 595.28 * 2;
  margin: 0 30px 10px 30px;
  padding-bottom: 20px;
  .headerLogo {
    display: flex;
    justify-content: flex-end;
    img {
      width: 100px;
      margin-bottom: 30px;
    }
  }
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 5px;
    .left {
      h6 {
        font-size: 22px;
        margin-bottom: 15px;
      }
      .h6 {
      }
    }
    .right {
      .div {
        border: 1px solid black;
        border-radius: 5px;
        margin-bottom: 20px;
        p {
          display: flex;
          justify-content: space-between;
          span {
            padding: 5px;
            // flex: 1;
          }
          // span:nth-child(2) {
          //   text-align: left;
          // }
          // span:nth-child(3) {
          //   text-align: right;
          // }
        }
      }
    }
  }

  main {
    margin-top: 20px;
    .tableHeader {
      margin-top: 20px;
      background: #00263a;
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      color: white;
      font-weight: bold;
      align-items: center;
      p {
        margin: 5px;
        font-size: 16px;
      }
    }
    table {
      width: 100%;
      border-collapse: collapse;
      .tr th {
        border-bottom: 1px solid #000;
        padding: 5px;
        text-align: right;
        width: 25%;
      }
      tr td {
        text-align: right;
        width: 25%;
      }
      tr td,
      tr h6 {
        padding: 5px;
        font-size: 14px;
      }
      tr td:nth-child(1) {
        text-align: left;
      }
      tr td:nth-child(2) {
        text-align: left;
      }
      tr th:nth-child(1) {
        text-align: left;
      }
      tr th:nth-child(2) {
        text-align: left;
      }
      .footer_tr td {
        padding-top: 20px;
      }
    }
  }
}
</style>
